import { fork, put, takeLatest, select } from 'redux-saga/effects';

import { createWorkersForPage } from '../../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import * as lendingApiActions from '../../../api/lendingAPI/LendingAPI.actions';
import { putAndWaitHandleAllAPIError } from '../../../api/API.sagas';
import * as selectors from './dashboardSelectors';

import {
    ACTIVATE_RLS_DASHBOARD,
    RLS_DASHBOARD_READY
} from './Dashboard.actions';

export const RLSDashboardSagasWorkers = createWorkersForPage({
    page: 'RLS_DASHBOARD',
    isInPageLocation: (location) =>
        location.pathname === '/recovery-loan-scheme/',
    createPageFlowWorkers: () => [fork(RLSDashboardPageWorkers)]
});

function* RLSDashboardPageWorkers() {
    yield takeLatest(ACTIVATE_RLS_DASHBOARD, function* () {
        yield putAndWaitHandleAllAPIError([
            { type: lendingApiActions.API_GET_CUSTOMER_STATE },
            { type: lendingApiActions.API_GET_ACCOUNTS }
        ]);

        const dashboardStatus = yield select(selectors.getDashboardStatus);

        yield put({
            type: RLS_DASHBOARD_READY,
            status: dashboardStatus
        });
    });
}
